import { ANDROID, IOS } from 'constants/deviceTypes';
import { INFORM_CHOICE } from 'constants/paths';
import { getDeviceContext } from './deviceContext';
import { shouldHideBackButton } from 'utils/shouldHideBackButton';

const AndroidInterface = window.AndroidInterface;
const webkit = window.webkit;

export function doMobileDocumentDownload(docId, type, device) {
  const isUUID = type === 'uuid';
  const { isNative } = getDeviceContext();
  if (isNative) {
    if (device === ANDROID) {
      isUUID
        ? AndroidInterface.downloadDocument(docId)
        : AndroidInterface.downloadDocumentFromUrl(docId);
    } else if (
      device === IOS &&
      (webkit.messageHandlers.downloadDocument || webkit.messageHandlers.downloadDocumentFromUrl)
    ) {
      isUUID
        ? webkit.messageHandlers.downloadDocument.postMessage(docId)
        : webkit.messageHandlers.downloadDocumentFromUrl.postMessage(docId);
    }
  }
}

export function sendErrorToMobileApp(error) {
  const { device, isNative } = getDeviceContext();
  if (isNative) {
    if (device === ANDROID) {
      AndroidInterface.throwError(JSON.stringify(error));
    } else if (device === IOS && webkit.messageHandlers.throwError) {
      webkit.messageHandlers.throwError.postMessage(JSON.stringify(error));
    }
  }
}

export function sendScreenDataToMobileApp(
  { access_token, currentPath, title = document.title },
  config,
  exitModalOpen,
  navigation
) {
  const { device } = getDeviceContext();
  const isBackButtonVisible = !shouldHideBackButton(exitModalOpen, config, currentPath, navigation);

  const dataToSend = JSON.stringify({
    back_button: {
      title: 'Back',
      visible: isBackButtonVisible,
      back_arrow_visible: isBackButtonVisible,
      navigation: currentPath === INFORM_CHOICE ? 'cancel' : 'webApp'
    },
    url: '',
    access_token,
    hide_tab_bar: true,
    title,
    screen_details: {
      screen_id: 0, //native app require value to be integer as per schema.It is not used in our App so its safe to send 0 for now.
      comp_state: 0
    }
  });

  if (device === ANDROID) {
    AndroidInterface.currentScreenDetails(dataToSend);
  } else if (device === IOS && webkit.messageHandlers.currentScreenDetails) {
    webkit.messageHandlers.currentScreenDetails.postMessage(dataToSend);
  }
}

/**
 * Send current screen details to mobile app. Will do nothing if not running in a Native app.
 * @param {*} accessToken
 * @param {*} redirectPath
 */
export function sendScreenDetailsToMobile(accessToken, path, config, exitModalOpen, navigation) {
  const { isNative } = getDeviceContext();

  if (isNative) {
    sendScreenDataToMobileApp(
      {
        access_token: accessToken,
        currentPath: path
      },
      config,
      exitModalOpen,
      navigation
    );
  }
}

export function webAppLoaded() {
  const { device, isNative } = getDeviceContext();
  if (isNative) {
    const webAppData = {
      screen_id: 0,
      comp_state: 0
    };
    if (device === ANDROID) {
      AndroidInterface.webAppLoaded(JSON.stringify(webAppData));
    } else if (device === IOS && webkit.messageHandlers.webAppLoaded) {
      webkit.messageHandlers.webAppLoaded.postMessage(JSON.stringify(webAppData));
    }
  }
}
